import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MonthlyReport } from '../models/inspection/monthly-report.model';
import { GlobalService } from '../providers/global.service';
import { RequestService } from '../providers/request/request.service';

@Injectable({
  providedIn: 'root',
})
export class InspectionMonthlyService extends RequestService<MonthlyReport> {
  static PATH = '/inspection/monthly';
  constructor(
    public override httpClient: HttpClient,
    private globalService: GlobalService
  ) {
    super(httpClient, InspectionMonthlyService.PATH, globalService.debugUrl);
  }
}
